import { createTheme } from "@mui/material/styles";

/** Monochrome light (white) and dark (black) themes for the whole app. */
export function createAppTheme(mode = "light") {
    const isLight = mode === "light";

    return createTheme({
        palette: {
            mode,
            primary: {
                main: isLight ? "#111111" : "#f5f5f5",
                light: isLight ? "#333333" : "#ffffff",
                dark: isLight ? "#000000" : "#cccccc",
                contrastText: isLight ? "#ffffff" : "#111111",
            },
            secondary: {
                main: isLight ? "#555555" : "#b0b0b0",
                contrastText: isLight ? "#ffffff" : "#111111",
            },
            background: {
                default: isLight ? "#f5f5f5" : "#0a0a0a",
                paper: isLight ? "#ffffff" : "#141414",
            },
            text: {
                primary: isLight ? "#111111" : "#f5f5f5",
                secondary: isLight ? "#555555" : "#a8a8a8",
            },
            divider: isLight ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)",
            action: {
                hover: isLight ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.06)",
                selected: isLight ? "rgba(0,0,0,0.08)" : "rgba(255,255,255,0.1)",
            },
        },
        typography: {
            fontFamily: '"Segoe UI", "Helvetica Neue", Arial, sans-serif',
            button: { textTransform: "none", fontWeight: 600 },
        },
        shape: { borderRadius: 10 },
        zIndex: {
            modal: 1500,
        },
        components: {
            MuiModal: {
                styleOverrides: {
                    root: {
                        zIndex: 1500,
                    },
                },
            },
            MuiCssBaseline: {
                styleOverrides: {
                    body: {
                        backgroundColor: isLight ? "#f5f5f5" : "#0a0a0a",
                        color: isLight ? "#111111" : "#f5f5f5",
                    },
                },
            },
            MuiAppBar: {
                defaultProps: { elevation: 0, color: "default" },
                styleOverrides: {
                    root: {
                        backgroundColor: isLight ? "#ffffff" : "#141414",
                        color: isLight ? "#111111" : "#f5f5f5",
                        borderBottom: isLight
                            ? "1px solid rgba(0,0,0,0.08)"
                            : "1px solid rgba(255,255,255,0.08)",
                    },
                },
            },
            MuiDrawer: {
                styleOverrides: {
                    paper: {
                        backgroundColor: isLight ? "#ffffff" : "#141414",
                        borderRight: isLight
                            ? "1px solid rgba(0,0,0,0.08)"
                            : "1px solid rgba(255,255,255,0.08)",
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundImage: "none",
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    containedPrimary: {
                        boxShadow: "none",
                        "&:hover": { boxShadow: "none" },
                    },
                },
            },
            MuiTableCell: {
                styleOverrides: {
                    head: {
                        fontWeight: 700,
                    },
                },
            },
        },
    });
}

export const THEME_STORAGE_KEY = "eduManageThemeMode";

export function readStoredThemeMode() {
    if (typeof window === "undefined") return "light";
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    return stored === "dark" ? "dark" : "light";
}
